<template>
    <div>
        <vapp-header btnBack btnTick :invoice_details="invoice_details_obj"></vapp-header>
        <div class="container">
            <div class="row invoice-details">
                <div class="col form-fnc">
                    <label>Invoice title<span>*</span></label>
                    <div class="form-group">
                        <input class="form-control padding-override" placeholder="Invoice 1" v-model="createInvoiceObj.title">
                    </div>
                    <label>Invoice number<span>*</span></label>
                    <div class="form-group">
                        <input class="form-control padding-override" placeholder="INV001" v-model="createInvoiceObj.no">
                    </div>
                    <label>Memo</label>
                    <div class="form-group">
                        <input class="form-control padding-override" placeholder="Summary" v-model="createInvoiceObj.memo">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    
    export default {
        data: () => ({}),
        computed: {
            ...mapState('invoice',['createInvoiceObj']),
        },
        mounted() {
            console.log("Mounted : Invoice Details");
        }
    }
</script>
